// Título do topo da lista (AC-192): saudação com o nome por 5 min, depois dicas curtas
// trocando a cada 20 s. A contagem começa quando o app abre e não reinicia ao trocar de tela.
import { useTranslation } from 'react-i18next';
import { firstName, greetingKey, newTitleSession, titleAt, type TitleSession } from '../domain/headerTitle';
import { useAppState, useStore } from '../state/AppStore';
import { useNow } from '../state/useNow';
import { cls } from './NewTaskForm';

let session: TitleSession | null = null;

/** Recomeça a saudação (testes). */
export function resetTitleSession(): void {
  session = null;
}

export function HeaderTitle({ className }: { className: string }) {
  const { t } = useTranslation();
  const store = useStore();
  const name = useAppState((s) => firstName(s.profile?.name));
  const now = useNow(1_000);
  session ??= newTitleSession(store.now());
  const shown = titleAt(now - session.start, session.order);

  if (shown.kind === 'tip') {
    return (
      <h1 key={`tip-${shown.slot}`} className={cls(className, 'head-title head-title--tip')} data-testid="header-title">
        {(t('tips', { returnObjects: true }) as string[])[shown.tip]}
      </h1>
    );
  }
  const key = greetingKey(session.style, new Date(now).getHours());
  return (
    <h1 key="greeting" className={cls(className, 'head-title')} data-testid="header-title">
      {t(`header.greeting.${key}`, { name: name ? `, ${name}` : '' })}
    </h1>
  );
}
